import React, { useCallback, useState } from 'react';
import { Box } from '@mui/material';

import getFile from '@/util/getFile';
// import { convertToMarkdown } from '../../../actions/document';
// import { useConfiguration } from '../../../providers/ConfigurationContext';
import UploadButton from '../UploadButton';
import ErrorSnackBar from '@/components/shared/ErrorSnackBar';
import type { DocumentUpload } from '@/types/sharedTypes';

const FORMATS = {
  DOCX: 'docx',
  DOCM: 'docm',
  TEXT: 'text',
  XLSX: 'xlsx',
  XLSM: 'xlsm',
  CSV: 'csv',
  PDF: 'pdf',
} as const;

const DOCUMENT_TYPES: Record<string, string> = {
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    FORMATS.DOCX,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    FORMATS.XLSX,
  'application/vnd.ms-excel.sheet.macroenabled.12': FORMATS.XLSX,
  'application/vnd.ms-word.document.macroenabled.12': FORMATS.DOCM,
  'text/plain': FORMATS.TEXT,
  'application/json': FORMATS.TEXT,
  'text/csv': FORMATS.CSV,
  'text/markdown': FORMATS.TEXT,
  'application/pdf': FORMATS.PDF,
};

interface DocumentUploaderProps {
  setDocuments: (docs: DocumentUpload[]) => void;
  disabled?: boolean;
  replacing?: boolean;
  label?: string;
  tooltip?: string;
}

function DocumentUploader({
  setDocuments,
  disabled,
  replacing,
  label,
  tooltip,
}: DocumentUploaderProps) {
  // const configuration = useConfiguration();
  const [doc_content, setDocContent] = useState(false);
  const [document_error, setDocumentError] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const handleUpload = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.files?.[0]) {
        setLoading(true);
        setDocumentError(undefined);
        const document = await getFile(e.target.files[0]);
        console.log(document);
        if (document) {
          // const processed = { name: document.name };
          const title = document.name;
          const type = DOCUMENT_TYPES[document.type];
          if (!type) {
            setDocumentError('Unsupported file format');
            setLoading(false);
            return;
          }
          // const markdown = await convertToMarkdown(
          //   api,
          //   title,
          //   type,
          //   document.base64contents.split(',')[1],
          //   undefined,
          //   ['table_conversion']
          // );
          // processed.contents = markdown.contents;
          // processed.processed_contents = markdown.processed_contents;
          setDocContent(true);
          setDocuments([
            {
              title,
              type,
              mime_type: document.type,
              base64_contents: document.base64contents.split(',')[1],
              pre_processing: [],
              post_processing: ['table_conversion'],
            },
          ]);
        }
        setLoading(false);
      }
    },
    [setDocuments],
  );

  return (
    <Box>
      <UploadButton
        onChange={handleUpload}
        variant='outlined'
        name={
          Boolean(doc_content) || replacing
            ? 'Replace Document'
            : label || 'Upload Document'
        }
        loading={loading}
        disabled={disabled}
        tooltip={
          Boolean(doc_content) || replacing
            ? 'Upload again to replace document'
            : tooltip || 'Upload a document'
        }
      />
      <ErrorSnackBar
        message={document_error}
        onClear={() => {
          setDocumentError(undefined);
        }}
      />
    </Box>
  );
}

export default DocumentUploader;

